import { render } from "./PositionPage.vue?vue&type=template&id=05c07ec6&ts=true"
import script from "./PositionPage.vue?vue&type=script&lang=ts"
export * from "./PositionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__